module.exports = __webpack_public_path__ + "static/media/MG.86f8e095.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/MG.svg
// module id = 2206
// module chunks = 7